import { DownloadConfigInfoType, DownloadParamsType } from '../types';
import { getOverviewCompetitorTimeline } from '@op/services';
import { dealWithMentionsSentimentChart } from '@op/pages/Overview/CompareKeyMetrics/utils';
import { formatTime } from '../renderHelper/time';

export const CompareKeyMetricsCommunityChart: DownloadConfigInfoType = {
  type: 'xlsx',
  columns({ auxiliaryParams }: DownloadParamsType) {
    const { metricHeader, isEngagementRate } = auxiliaryParams || {};
    return [
      {
        key: 'time',
        header: 'Date',
        renderHelper: [formatTime(auxiliaryParams?.filter)],
      },
      {
        key: 'name',
        header: 'Game',
      },
      {
        key: 'value',
        header: metricHeader || 'Value',
        numFmt: isEngagementRate ? '0.00%' : '0',
      },
    ];
  },
  downloadFunc: getOverviewCompetitorTimeline,
  dealWithDataFunc: ({ data, filter, auxiliaryParams }: DownloadParamsType) => {
    const { tableData } = dealWithMentionsSentimentChart(data, {
      ...filter,
      gameData: auxiliaryParams?.gameData,
    });
    return tableData;
  },
};
